import { motion } from "framer-motion";

export const reveal = {
  initial: { opacity: 0, y: 48 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1] },
};

export function SectionHeading({ eyebrow, title, sub, align = "left" }) {
  return (
    <motion.div
      {...reveal}
      className={`mb-14 sm:mb-20 ${align === "center" ? "text-center" : ""}`}
    >
      <p className="font-telemetry text-xs uppercase tracking-[0.25em] text-blaze mb-4">
        {eyebrow}
      </p>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] text-bone">
        {title}
      </h2>
      {sub && (
        <p className="mt-5 max-w-xl text-sm sm:text-base leading-relaxed text-ash">
          {sub}
        </p>
      )}
    </motion.div>
  );
}
